
import Vue from 'vue';
import { Wrapper } from './styles';

export default Vue.extend({
  components: {
    Wrapper,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      default: '',
    },
    atived: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      active: false,
    };
  },
  computed: {
    visible(): boolean {
      return this.active;
    },
  },
  methods: {
    open() {
      this.active = !this.active;
    },
    start(el: any) {
      const element = el;
      element.style.height = `${element.scrollHeight}px`;
    },
    end(el: any) {
      const element = el;
      element.style.height = '';
    },
  },
  created() {
    this.active = this.atived;
  },
});
